module.exports = __webpack_public_path__ + "static/media/ic-payment.b423abdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-payment.svg
// module id = 652
// module chunks = 14